<template>
	<div class="flex flex-col">
		<div class="prose wrap-break-word lg:prose-lg xl:prose-xl">
			<sb-rich-text :document="blok.content" />
		</div>
	</div>
</template>

<script setup lang="ts">
import type {ISbStoryData} from "@storyblok/js";

defineProps<{
	blok: ISbStoryData["content"];
}>();
</script>
